import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import RoadmapHeader from '../components/roadmap/RoadmapHeader';
import RoadmapTimeline from '../components/roadmap/RoadmapTimeline';
import RoadmapNotes from '../components/roadmap/RoadmapNotes';

export default function Roadmap() {
  return (
    <>
      <Helmet>
        <title>RentFi | Development Roadmap</title>
        <meta 
          name="description" 
          content="Explore RentFi's strategic development roadmap from 2024 to 2026. Learn about our milestones, upcoming features, and vision for revolutionizing real estate investment through blockchain technology." 
        />
        <meta 
          name="keywords" 
          content="RentFi roadmap, blockchain real estate development, property investment milestones, real estate tokenization timeline, RENT token development" 
        />
        <link rel="canonical" href="https://rentfi.io/roadmap" />
      </Helmet>
      <div className="min-h-screen bg-gray-50 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <RoadmapHeader />
            <RoadmapTimeline />
            <RoadmapNotes />
          </motion.div>
        </div>
      </div>
    </>
  );
}